import { mapCCESItemToDetailsObject } from '../../../utils/ccesUtils';
import { checkMissingParams, fetchCCESExtensions } from './index';

export default async (params, signal) => {
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
  };
  const requiredParams = ['appId'];
  checkMissingParams(params, requiredParams, paramsRules);
  const requestBody = {
    filters: {
      identifiers: {
        extensionIds: [params.appId],
      },
    },
  };
  const response = await fetchCCESExtensions(signal, requestBody, params.authToken);
  const content = { apps: response?.items.map(mapCCESItemToDetailsObject) };
  return content;
};
